import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {MemberModel} from '../../../models/user.model';
import {HelpersService} from '../../../services/helpers.service';
import {crc1} from 'crc';
import {MemberService} from '../../../services/member.service';

@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements OnInit {
    @Input() public profile: MemberModel;
    @Input() public size: 'mini' | 'medium' | 'full';
    @Input() public detailProfile = false;
    @Input() public avatarFrame = false;
    @Input() public successFrame = false;

    @Output() public hasAvatar: EventEmitter<boolean> = new EventEmitter<boolean>();

    avatar = {
        letter: '',
        profileBackgroundColor: ''
    };

    memberAvatar: SafeResourceUrl;

    colors = [['d73828', 'e06a4d'], ['005d83', '4f8cad'],
        ['609c40', '9db37d'], ['901f46', 'b06071'],
        ['fbad18', 'ffd594'], ['f57e25', 'fbba89'],
        ['fff08b', 'f8d800'], ['ce9ffc', '7367f0'],
        ['90f7ec', '32ccbc'], ['81fbb8', '28c76f'],
        ['fccf31', 'f55555'], ['f761a1', '8c1bab']];

    constructor(
        public helper: HelpersService,
        private memberService: MemberService,
        private sanitizer: DomSanitizer,
    ) {
    }

    ngOnInit(): void {
        const randomNumber = crc1(this.profile.email) % this.colors.length;
        const fName = this.profile.firstname ? this.profile.firstname.charAt(0).toUpperCase() : '';
        const lName = this.profile.lastname ? this.profile.lastname.charAt(0).toUpperCase() : '';
        const name = fName + lName;
        this.avatar.profileBackgroundColor = 'background: linear-gradient(to right, #' +
            (this.colors)[randomNumber][0] + ', #' +
            (this.colors)[randomNumber][1] + ')';
        this.avatar.letter = name ? name : this.profile.email.charAt(0).toUpperCase();

        if (this.profile.has_avatar) {
            this.getAvatar();
        }
    }

    getAvatar(): void {
        this.memberService.getAvatar(true, this.profile.guid).subscribe({
            next: res => {
                this.memberAvatar = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(res));
                this.hasAvatar.emit(true);
            }, error: err => {
                this.hasAvatar.emit(false);
            }
        });
    }

    openProfile(event: MouseEvent): void {
        if (this.detailProfile) {
            return;
        }
        event.stopPropagation();
        event.preventDefault();
        this.helper.openProfileByGuid(this.profile.guid);
    }
}
